export class ArrayUtils {
    public static getRange(start: number, end: number) {
        return Array.from({length: (end - start)}, (v, k) => k + start);
    }

    public static getBy<T>(source: T[], predicate: (value: T) => boolean) {
        return source.filter(predicate)[0];
    }
}